import * as React from "react";
import { Lightbox, LightboxType } from "../../../../../../../react-core/Html/Components/Lightbox";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SectionHeader } from "../../SharedComponents";

interface IInformationProps extends IProcessComponentProps {}

interface IInformationState {
    showDetail: boolean;
}

export class Information extends ProcessComponent<IInformationProps, IInformationState> {
    constructor(props: any) {
        super(props);
        this.state = { showDetail: false };
    }

    public render(): JSX.Element {
        return (
            <>
                {SectionHeader("Information")}
                <p>
                    Please be aware that your selection of assets may affect how early we can pay your client’s Pension
                    Commencement Lump Sum (PCLS) and income.{" "}
                </p>
                <a className="hyperlink" onClick={() => this.setState({ showDetail: true })}>
                    Click here for more detail{" >>"}
                </a>
                <p>
                    For more general guidance on our drawdown process{" "}
                    <a href="javascript:void(0);" target="_blank">
                        click here{" >>"}
                    </a>
                </p>

                {this.state.showDetail && (
                    <Lightbox
                        show={this.state.showDetail}
                        title={""}
                        contentAfterTitle={null}
                        onClose={() => this.setState({ showDetail: false })}
                        type={LightboxType.Modal}
                        unclosable={true}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        <p>TBC</p>
                        <button className="btn primary" onClick={() => this.setState({ showDetail: false })}>
                            OK
                        </button>
                    </Lightbox>
                )}
            </>
        );
    }
}
